import cookie from 'cookie';

/*
CookieOptions = {
  expire?: number | Date
  maxAge?: number
  domain?: string
  path?: string
  secure?: boolean
  httpOnly?: boolean
}
*/

export const getCookieOpts = () => {
  const base = {
    maxAge: 60 * 60 * 24 * 14, // 2 weeks
    secure: !['app.veritasratings.local', 'localhost'].includes(
      window.location.hostname,
    ),
    httpOnly: false,
    path: '/',
  };

  /**
   * On localhost the domain parameter HAS TO BE excluded
   * altogether from the parameters.
   */
  if (window.location.hostname !== 'localhost') {
    base.domain = window.location.hostname;
  }

  return base;
};

export const getByteSize = (obj) => {
  const str = typeof obj !== 'string' ? JSON.stringify(obj) : obj;
  return Buffer.from(str).length;
};

export const setCookie = (name, value, options = {}) => {
  const rawCookie = {};
  rawCookie[name] = value;

  if (typeof value === 'object') {
    rawCookie[name] = JSON.stringify(value);
  }

  const serialized = cookie.serialize(name, rawCookie[name], options);
  window.document.cookie = serialized;
  // Also store in localStorage as fallback (for httpOnly cookies in dev when connecting to prod api)
  window.localStorage.setItem(`cookie_${name}`, rawCookie[name]);

  return window.document.cookie;
};

export const getCookie = (name) => {
  const cookies = cookie.parse(window.document.cookie);
  let value = cookies && cookies[name];

  if (!value) {
    // Fallback to localStorage if cookie is httpOnly
    // Hack to be able to check out the prod data in local dev
    const localValue = window.localStorage.getItem(`cookie_${name}`);
    if (localValue) return localValue;
    else return null;
  }

  const hasToParse = (value && value[0] === '{') || value[0] === '[';

  return hasToParse ? JSON.parse(value) : value;
};

export const removeCookie = (name) => {
  const options = { expires: new Date(1970, 1, 1, 0, 0, 1), maxAge: 0 };

  window.document.cookie = cookie.serialize(name, '', options);

  return window.document.cookie;
};
